export default "__VITE_ASSET__DyHmBqMw__"